import React from 'react';
import {
  StyleSheet,
  View,
  Text,
  ScrollView,
  TouchableOpacity,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import theme from '../../theme';

export const SettingsScreen: React.FC = () => {
  const navigation = useNavigation<StackNavigationProp<any>>();

  const settingsOptions = [
    {
      title: 'Activity Log',
      description: 'View all system activity and changes (Admin Only)',
      icon: 'time-outline',
      screen: 'ActivityLog',
      adminOnly: true,
    },
    {
      title: 'Vehicle Pricing',
      description: 'Manage vehicle costs and company share rates',
      icon: 'cash-outline',
      screen: 'VehicleRateSettings',
      adminOnly: false,
    },
    {
      title: 'Display Options',
      description: 'Customize what fields appear on vehicle and driver cards',
      icon: 'eye-outline',
      screen: 'DisplayOptions',
      adminOnly: true,
    },
    {
      title: 'Backup & Export',
      description: 'Export data and create system backups',
      icon: 'cloud-download-outline',
      screen: 'BackupExport',
      adminOnly: true,
    },
    {
      title: 'Driver Sync',
      description: 'Upload CSV to sync driver database (Super Admin Only)',
      icon: 'sync',
      screen: 'DriverSync',
      adminOnly: true,
    },
    {
      title: 'User Management',
      description: 'Manage users and permissions (Coming Soon)',
      icon: 'people-outline',
      screen: 'UserManagement',
      adminOnly: true,
    },
    {
      title: 'System Configuration',
      description: 'Configure system settings (Coming Soon)',
      icon: 'settings-outline',
      screen: null, // TODO: Implement
      adminOnly: true,
    },
  ];

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Text style={styles.headerTitle}>الإعدادات / Settings</Text>
      </View>

      <ScrollView style={styles.content}>
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>System Settings</Text>
          {settingsOptions.map((option, index) => (
            <TouchableOpacity
              key={index}
              style={styles.optionCard}
              onPress={() => {
                if (option.screen) {
                  navigation.navigate(option.screen);
                }
              }}
              disabled={!option.screen}
            >
              <View style={styles.optionIcon}>
                <Ionicons name={option.icon as any} size={24} color={theme.colors.primary} />
              </View>
              <View style={styles.optionContent}>
                <View style={styles.optionHeader}>
                  <Text style={styles.optionTitle}>{option.title}</Text>
                  {option.adminOnly && (
                    <View style={styles.adminBadge}>
                      <Text style={styles.adminBadgeText}>Admin</Text>
                    </View>
                  )}
                </View>
                <Text style={styles.optionDescription}>{option.description}</Text>
              </View>
              <Ionicons name="chevron-forward" size={20} color={theme.colors.gray400} />
            </TouchableOpacity>
          ))}
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.colors.gray50,
  },
  header: {
    backgroundColor: theme.colors.white,
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.border,
  },
  headerTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    color: theme.colors.textPrimary,
  },
  content: {
    flex: 1,
  },
  section: {
    padding: 16,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: theme.colors.textPrimary,
    marginBottom: 12,
  },
  optionCard: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: theme.colors.white,
    padding: 16,
    borderRadius: 12,
    marginBottom: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  optionIcon: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: theme.colors.primaryLight,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  optionContent: {
    flex: 1,
  },
  optionHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  optionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: theme.colors.textPrimary,
    marginRight: 8,
  },
  adminBadge: {
    backgroundColor: theme.colors.warning,
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 4,
  },
  adminBadgeText: {
    fontSize: 10,
    fontWeight: '600',
    color: theme.colors.white,
  },
  optionDescription: {
    fontSize: 14,
    color: theme.colors.gray600,
  },
});
